webpackJsonp([70442054423227],{

/***/ 2568:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lore-tutorial-twitter.2ce7aea9.png";

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _language = __webpack_require__(203);
	
	var _language2 = _interopRequireDefault(_language);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LanguagePreference = function (_React$Component) {
	  _inherits(LanguagePreference, _React$Component);
	
	  function LanguagePreference() {
	    _classCallCheck(this, LanguagePreference);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  LanguagePreference.prototype.componentWillMount = function componentWillMount() {
	    try {
	      this.setState({
	        language: _language2.default.getLanguage()
	      });
	    } catch (error) {
	      this.setState({
	        language: 'ES6'
	      });
	    }
	  };
	
	  LanguagePreference.prototype.setLanguage = function setLanguage(language) {
	    _language2.default.saveLanguage(language);
	    this.setState({
	      language: language
	    });
	  };
	
	  LanguagePreference.prototype.render = function render() {
	    var _this2 = this;
	
	    var language = this.state.language;
	
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'language-selector', className: 'panel panel-default', style: { marginTop: '32px' } },
	      _react2.default.createElement(
	        'div',
	        { style: { padding: '15px' } },
	        _react2.default.createElement(
	          'h3',
	          { style: { marginTop: '0px', marginBottom: '8px' } },
	          'Language Preference'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { paddingBottom: '16px' } },
	          'The code in this quickstart can be displayed in one of three versions of JavaScript. Which version would you like to see?'
	        ),
	        _react2.default.createElement(
	          'blockquote',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            'All versions use ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'import'
	            ),
	            ' and ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'export'
	            ),
	            ' statements, as well as syntax like ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'const'
	            ),
	            ' and ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'let'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The only difference between ES5 and ES6 is how you prefer to construct your React components.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'list-group', style: { marginBottom: 0 } },
	          _react2.default.createElement(
	            'button',
	            { className: 'list-group-item' + (language === 'ES5' ? ' active' : ''), style: { outline: 'none' }, onClick: function onClick() {
	                _this2.setLanguage('ES5');
	              } },
	            _react2.default.createElement(
	              'h4',
	              { className: 'list-group-item-heading' },
	              'ES5'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'list-group-item-text' },
	              'I prefer to use ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'createReactClass'
	              ),
	              ' for my components.'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'list-group-item' + (language === 'ES6' ? ' active' : ''), style: { outline: 'none' }, onClick: function onClick() {
	                _this2.setLanguage('ES6');
	              } },
	            _react2.default.createElement(
	              'h4',
	              { className: 'list-group-item-heading' },
	              'ES6'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'list-group-item-text' },
	              'I prefer to create my components with ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'classes'
	              ),
	              ' using ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'React.Component'
	              ),
	              '.'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'list-group-item' + (language === 'ESNext' ? ' active' : ''), style: { outline: 'none' }, onClick: function onClick() {
	                _this2.setLanguage('ESNext');
	              } },
	            _react2.default.createElement(
	              'h4',
	              { className: 'list-group-item-heading' },
	              'ESNext'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'list-group-item-text' },
	              'I prefer to use ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'React.Component'
	              ),
	              ', but also want to use next-gen features like ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'static property types'
	              ),
	              ' and ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'decorators'
	              ),
	              '.'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return LanguagePreference;
	}(_react2.default.Component);
	
	exports.default = LanguagePreference;
	;
	module.exports = exports['default'];

/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _LanguagePreference = __webpack_require__(281);
	
	var _LanguagePreference2 = _interopRequireDefault(_LanguagePreference);
	
	var _loreTutorialTwitter = __webpack_require__(2568);
	
	var _loreTutorialTwitter2 = _interopRequireDefault(_loreTutorialTwitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Introduction'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This Quickstart is intended to provide a fast-paced introduction to Lore, to give you a sense of what the framework feels like and whether it\'s something you want to invest more time in.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Explanations for the opinions expressed in the framework will be left for elsewhere in the documentation.'
	    ),
	    _react2.default.createElement(_LanguagePreference2.default, null),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'What You\'ll Build'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is the application we\'ll be building. It is a Twitter-like app, pre-populated with characters and quotes from ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://en.wikipedia.org/wiki/Chrono_Trigger' },
	        'Chrono Trigger'
	      ),
	      '.'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _loreTutorialTwitter2.default }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Concepts Covered'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This Quickstart will cover the following concepts:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Creating and building a React application'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Layout out your application visuals with mock data'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Routing'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Fetching data from an API server'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Populating your application with real data'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Generating and launching dialogs'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Authentication (logging users in)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Authorization (restricting what users see)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Resolving breaking API changes'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Pagination'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Infinite Scrolling'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Filtering data'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Normalizing API data'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Optimistic updates (displaying changes before server confirmation)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Integrating Websockets for real-time behavior'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Publishing your application'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Questions/Issues'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you have any questions or concerns while navigating through the Quickstart, please ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/issues' },
	        'submit an issue on GitHub'
	      ),
	      '. Your feedback is appreciated as a way to make the Quickstart better.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Ready? Let\'s ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/quickstart/setup/overview/' },
	        'get started'
	      ),
	      '!'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-index-js-8c483430cf102c64f2e1.js